import events from "_src/engine/events";
import workspace from "_src/workspace";

let _status = null;
export default {

  init() {
    _status = {};

    for (const object of workspace.getObjects()) {
      _status[object.getID()] = {0: _getObjectStatus(object)};
    }

    for (const photoGroup of workspace.getPhotoGroups()) {
      _status[photoGroup.getID()] = {0: _getPhotoGroupStatus(photoGroup)};
    }

    _reportStatus();
  },

  updateObjectStatus(object, level) {
    _status[object.getID()][level] = _getObjectStatus(object);
    _reportStatus();
  },

  updatePhotoGroupStatus(photoGroup) {
    _status[photoGroup.getID()][0] = _getPhotoGroupStatus(photoGroup);
    _reportStatus();
  },

  cleanup() {
    _status = null;
  }

};

function _getObjectStatus(object) {
  let chunksCount = 0;
  let chunksLoaded = 0;
  for (const frame of object.frames) {
    if (!frame.shouldBeLoaded) continue;

    chunksCount += frame.model.chunks.length;
    chunksLoaded += frame.model.chunks.filter(chunk => !chunk.needsReload).length;
  }

  return chunksCount > 0 ? Math.floor(100 * chunksLoaded / chunksCount) : 0;
}

function _getPhotoGroupStatus(photoGroup) {
  const photosCount = photoGroup.photos.size;
  let photosLoaded = 0;
  for (const photo of photoGroup.photos.values()) {
    if (photo.mip) photosLoaded++;
  }

  return photosCount > 0 ? Math.floor(100 * photosLoaded / photosCount) : 0;
}

function _reportStatus() {
  events.emit("loadingProgress", _status);
}
